import { api } from '../../api/client';
import type {
  ArenaScenarioInfo,
  ArenaTaskDto,
  ArenaRunDto,
  ArenaRunMode,
} from './types';

export const arenaApi = {
  listScenarios: () =>
    api.get<ArenaScenarioInfo[]>('/arena/scenarios'),

  listTasks: (params?: { status?: string; difficulty?: string; category?: string }) =>
    api.get<ArenaTaskDto[]>('/arena/tasks', params as Record<string, string>),

  createTask: (scenarioId: string) =>
    api.post<ArenaTaskDto>('/arena/tasks', { scenarioId }),

  startRun: (taskId: string, mode: ArenaRunMode) =>
    api.post<ArenaRunDto>(`/arena/tasks/${taskId}/run`, { mode }),

  getRun: (runId: string) =>
    api.get<ArenaRunDto>(`/arena/runs/${runId}`),

  approveRun: (runId: string) =>
    api.post<void>(`/arena/runs/${runId}/approve`),

  validateRun: (runId: string) =>
    api.post<ArenaRunDto>(`/arena/runs/${runId}/validate`),

  updateRun: (runId: string, data: { status: string; agentActions?: unknown[]; errorMessage?: string; relatedReportCode?: string }) =>
    api.put<void>(`/arena/runs/${runId}`, data),
};
